let exports = {
   addCardsCorporate: {
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12', model: 'name', sub_label: 'To be imprinted on card',
            validation: 'required|min:3|max:24', label: 'Cardholder Name', err: ''
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'lastName',
            validation: 'required|min:3|max:20', label: 'Last Name', err: ''
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'idType', filterable: true, clearable: true,
            options: [
               { val: 'national_id', label: 'National ID' },
               { val: 'passport', label: 'Passport' },
            ],
            validation: 'required', label: 'ID Type'
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'idNumber',
            validation: 'required|min:1|max:15', label: 'ID Number/Passport Number', err: ''
         },
         
         {
            type: 'select', class: 'col-12 col-md-6', model: 'productRestriction', filterable: true, clearable: true,
            options: [
               { val: 'all_products', label: 'All Products' },
               { val: 'unleaded_gasoline', label: 'Unleaded Gasoline' },
               { val: 'diesel', label: 'Diesel' },
               { val: 'lubricants', label: 'Lubricants' },
               { val: 'service_grease', label: 'Service & Grease' },
               { val: 'k-gas', label: 'K-Gas' },
               { val: 'other_products', label: 'Other Products' },
            ], sub_label: 'select one product',
            validation: 'required', label: 'Choose your product restriction', sub_label_bottom: 'Tick only one choice among the list below'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'authorizedZones', clearable: true,
            options: [
               { val: 'all_zones', label: 'All Zones' },
               { val: 'LUSAKA', label: 'LUSAKA' },
               { val: 'COPPERBELT', label: 'COPPERBELT' },
               { val: 'EASTERN', label: 'EASTERN' },
               { val: 'SOUTHERN', label: 'SOUTHERN' },
               { val: 'WESTERN', label: 'WESTERN' },
               { val: 'CENTRAL', label: 'CENTRAL' },
            ], sub_label: 'select one or multiple zones',
            validation: 'required', label: 'Authorized Zones', multiple: true, max_tag_count: 2
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'daysOfUse', clearable: true,
            options: [
               { val: 'all_days', label: 'All Days' },
               { val: 'Monday', label: 'Monday' },
               { val: 'Teusday', label: 'Teusday' },
               { val: 'Wednesday', label: 'Wednesday' },
               { val: 'Thursday', label: 'Thursday' },
               { val: 'Friday', label: 'Friday' },
               { val: 'Saturday', label: 'Saturday' },
               { val: 'Sunday', label: 'Sunday' },
            ], sub_label: 'Select appropriate',
            validation: 'required', label: 'Days of Use', multiple: true, max_tag_count: 2
         },
         {
            type: 'checkbox', class: 'col-12 custom-check padded', model: 'sms', validation: '',
            label: 'SMS Alerts <br> <label class="small-label-bottom">Attract a cost of 0.31 ZMW per alert</label>', sub_label_bottom: ''
         },
         {
            type: 'checkbox', class: 'col-12 custom-check padded', model: 'millageInput', validation: '',
            label: 'Millage Input <br> <label class="small-label-bottom">Select if you want a report of fuel consumption efficiency in Litres per 100Kms</label>'
         },
         {
            type: 'checkbox', class: 'col-12 custom-check padded', model: 'driverCode', validation: '',
            label: 'Driver Code <br> <label class="small-label-bottom">Tick if you want a driver code to be captured on POS, so as to identify each driver individually</label>'
         },
      ],
      table: {
         icon: 'fa fa-credit-card',
         title: 'Cards',
         table_fields: [
            { name: 'First Name', align: 'c' },
            { name: 'Last Name', align: 'c' },
            { name: 'Product Restriction', align: 'c' },
            { name: 'Vehicle Registration', align: 'c' },
            { name: 'Actions', align: 'c' }
         ],
         search_fields: ["firstName", "lastName", "vehicleReg","productRestriction"],
         row_data: [
            { type: 'text', field: 'firstName', class: 'bold center' },
            { type: 'text', field: 'lastName', class: 'bold center' },
            { type: 'text', field: 'productRestriction', class: 'bold center' },
            { type: 'text', field: 'vehicleReg', class: 'bold center' },
            {
               type: 'action', field: 'name', class: 'center', icon: '', actions: [
                  // {type: 'title', title: 'Actions'},
                  { type: 'menu', title: 'View', event: 'table:view' },
                  { type: 'menu', title: 'Delete', event: 'table:delete', icon: 'fa-trash-alt' },
               ]
            },
         ]
      }
   },
   addCardsIndividual: {
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-11 col-md-6 input-uppercase', model: 'vehicleReg',
            validation: 'min:7|max:8', label: 'Vehicle Registration', err: '', sub_label_bottom: 'NOTE: Leave blank if you do not wish to restrict this card to one vehicle', sub_label: 'To be imprinted on card'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'productRestriction', filterable: true, clearable: true,
            options: [
               { val: 'all_products', label: 'All Products' },
               { val: 'unleaded_gasoline', label: 'Unleaded Gasoline' },
               { val: 'diesel', label: 'Diesel' },
               { val: 'lubricants', label: 'Lubricants' },
               { val: 'service_grease', label: 'Service & Grease' },
               { val: 'k-gas', label: 'K-Gas' },
               { val: 'other_products', label: 'Other Products' },
            ], sub_label: 'select one product',
            validation: 'required', label: 'Product Restriction'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'authorizedZones', clearable: true,
            options: [
               { val: 'all_zones', label: 'All Zones' },
               { val: 'LUSAKA', label: 'LUSAKA' },
               { val: 'COPPERBELT', label: 'COPPERBELT' },
               { val: 'EASTERN', label: 'EASTERN' },
               { val: 'SOUTHERN', label: 'SOUTHERN' },
               { val: 'WESTERN', label: 'WESTERN' },
               { val: 'CENTRAL', label: 'CENTRAL' },
            ], sub_label: 'select one or multiple zones',
            validation: 'required', label: 'Authorized Zones', multiple: true, max_tag_count: 2
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'daysOfUse', clearable: true,
            options: [
               { val: 'all_days', label: 'All Days' },
               { val: 'Monday', label: 'Monday' },
               { val: 'Teusday', label: 'Teusday' },
               { val: 'Wednesday', label: 'Wednesday' },
               { val: 'Thursday', label: 'Thursday' },
               { val: 'Friday', label: 'Friday' },
               { val: 'Saturday', label: 'Saturday' },
               { val: 'Sunday', label: 'Sunday' },
            ], sub_label: 'Select appropriate',
            validation: 'required', label: 'Days of Use', multiple: true, max_tag_count: 2
         },
         {
            type: 'checkbox', class: 'col-12 custom-check padded', model: 'sms', validation: '',
            label: 'SMS Alerts <br> <label class="small-label-bottom">Attract a cost of 0.31 ZMW per alert</label>', sub_label_bottom: ''
         },
         {
            type: 'checkbox', class: 'col-12 custom-check padded', model: 'millageInput', validation: '',
            label: 'Millage Input <br> <label class="small-label-bottom">Select if you want a report of fuel consumption efficiency in Litres per 100Kms</label>'
         },
         {
            type: 'checkbox', class: 'col-12 custom-check padded', model: 'driverCode', validation: '',
            label: 'Driver Code <br> <label class="small-label-bottom">Tick if you want a driver code to be captured on POS, so as to identify each driver individually</label>'
         },
      ],
      table: {
         icon: 'fa fa-credit-card',
         title: 'Cards',
         table_fields: [
            { name: 'Product Restriction', align: 'c' },
            { name: 'Vehicle Registration', align: 'c' },
            { name: 'Actions', align: 'c' }
         ],
         search_fields: ["firstName", "lastName", "vehicleReg","productRestriction"],
         row_data: [
            { type: 'text', field: 'productRestriction', class: 'bold center' },
            { type: 'text', field: 'vehicleReg', class: 'bold center' },
            {
               type: 'action', field: 'name', class: 'center', icon: '', actions: [
                  // {type: 'title', title: 'Actions'},
                  { type: 'menu', title: 'View', event: 'table:view' },
                  { type: 'menu', title: 'Delete', event: 'table:delete', icon: 'fa-trash-alt' },
               ]
            },
         ]
      }
   },
}

let forms = {
   select_payment_option: {
      icon: 'fa fa-pound-sign',
      title: 'Verify Payment',
      subtitle: 'Payment Verification',
      forms: [
         {
            type: 'select', class: 'col-12', model: 'payment_option', filterable: true, clearable: true,
            multiple: false, options: [], validation: '', label: 'Payment Option'
         },
      ]
   },
   payment_receipt: {
      icon: 'fa fa-pound-sign',
      title: 'Verify Payment',
      subtitle: 'Payment Verification',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12', model: 'payment_receipt',
            validation: 'min:3|max:16', label: 'Payment Receipt', err: '', sub_label_bottom: 'NOTE: You can optionally provide the payment receipt number if paid already'
         },
      ]
   },
   company_card_details_left: {
      icon: 'fa fa-user',
      title: 'Contact Details',
      subtitle: 'Provide contact info',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 input-uppercase', model: 'name', sub_label: 'To be imprinted on card',
            validation: 'required|min:3|max:24', label: 'Cardholder Name*', err: ''
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6 input-uppercase', model: 'companyName',
            validation: 'required|min:3|max:100', label: 'Company Name*', err: '', sub_label: 'To be imprinted on card if different from above',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'companyRegistrationNo',
            validation: 'required|min:1|max:100', label: 'Company Registration No.*', err: '', sub_label: 'Provide a valid company registration number',
         },
         {
            type: 'mobile', class: 'col-12', model: 'mobileNo', filterable: true, validation: 'required',
            label: 'Mobile Number*', validation: 'required|numeric|min:9|max:10', err: ''
         },
         {
            type: 'checkbox-group', class: 'col-12 laz-radio', model: 'productRestriction', validation: 'required',
            options: [
               { val: 'all_products', label: '<div class="group-radio"><div class="black">All Products</div><div class="small-text">(Unleaded/Super+Diesel+Kerosene+Lubes+Service&Grease+K-Gas)</div></div>', class: 'col-12 main-radio', checked: false, select_all: true },
               { val: 'unleaded_gasoline', label: 'Unleaded Gasoline', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'diesel', label: 'Diesel', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'lubricants', label: 'Lubricants', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'service_grease', label: 'Service & Grease', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'k-gas', label: 'K-Gas', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'other_products', label: 'Other Products', class: 'col-12 col-md-6 col-lg-4',checked: false },
            ], classes: { radioRow: 'row', radioCol: 'col-12 col-md-6 col-lg-4' }, label: 'Choose your product restriction*', sub_label: 'Tick and fill appropriate'
         },
         {
            type: 'checkbox-group', class: 'col-12 laz-radio smaller', model: 'authorizedZones', validation: 'required',
            options: [
               { val: 'all_zones', label: '<div class="group-radio"><div class="black">All Zones</div><div class="small-text">(LUSAKA+COPPERBELT+EASTERN+SOUTHERN+WESTERN+CENTRAL)</div></div>', class: 'col-12 main-radio', select_all: true,checked: false },
               { val: 'LUSAKA', label: 'LUSAKA', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'COPPERBELT', label: 'COPPERBELT', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'EASTERN', label: 'EASTERN', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'SOUTHERN', label: 'SOUTHERN', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'WESTERN', label: 'WESTERN', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'CENTRAL', label: 'CENTRAL', class: 'col-12 col-md-6 col-lg-4',checked: false },
            ], classes: { radioRow: 'row', radioCol: 'col-12 col-md-6 col-lg-4' }, label: 'Authorized zones of use*', sub_label: 'Tick one or multiple zones below'
         },
      ]
   },
   card_details_left: {
      icon: 'fa fa-user',
      title: 'Contact Details',
      subtitle: 'Provide contact info',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 input-uppercase', model: 'name', sub_label: 'To be imprinted on card',
            validation: 'required|min:3|max:24', label: 'Cardholder Name*', err: ''
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'idType', filterable: true, clearable: true,
            options: [
               { val: 'national_id', label: 'National ID' },
               { val: 'passport', label: 'Passport' },
            ],
            validation: 'required', label: 'ID Type*'
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'idNumber',
            validation: 'required|min:1|max:15', label: 'ID/Passport No.*', err: ''
         },
         {
            type: 'mobile', class: 'col-12', model: 'mobileNo', filterable: true, validation: 'required',
            label: 'Mobile Number*', validation: 'required|numeric|min:9|max:10', err: ''
         },
         {
            type: 'checkbox-group', class: 'col-12 laz-radio', model: 'productRestriction', validation: 'required',
            options: [
               { val: 'all_products', label: '<div class="group-radio"><div class="black">All Products</div><div class="small-text">(Unleaded/Super+Diesel+Kerosene+Lubes+Service&Grease+K-Gas)</div></div>', class: 'col-12 main-radio',checked: false, select_all: true },
               { val: 'unleaded_gasoline', label: 'Unleaded Gasoline', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'diesel', label: 'Diesel', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'lubricants', label: 'Lubricants', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'service_grease', label: 'Service & Grease', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'k-gas', label: 'K-Gas', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'other_products', label: 'Other Products', class: 'col-12 col-md-6 col-lg-4',checked: false },
            ], classes: { radioRow: 'row', radioCol: 'col-12 col-md-6 col-lg-4',checked: false }, label: 'Choose your product restriction*', sub_label: 'Tick and fill appropriate'
         },
         {
            type: 'checkbox-group', class: 'col-12 laz-radio smaller', model: 'authorizedZones', validation: 'required',
            options: [
               { val: 'all_zones', label: '<div class="group-radio"><div class="black">All Zones</div><div class="small-text">(LUSAKA+COPPERBELT+EASTERN+SOUTHERN+WESTERN+CENTRAL)</div></div>', class: 'col-12 main-radio', select_all: true,checked: false },
               { val: 'LUSAKA', label: 'LUSAKA', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'COPPERBELT', label: 'COPPERBELT', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'EASTERN', label: 'EASTERN', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'SOUTHERN', label: 'SOUTHERN', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'WESTERN', label: 'WESTERN', class: 'col-12 col-md-6 col-lg-4',checked: false },
               { val: 'CENTRAL', label: 'CENTRAL', class: 'col-12 col-md-6 col-lg-4',checked: false },
            ], classes: { radioRow: 'row', radioCol: 'col-12 col-md-6 col-lg-4' }, label: 'Authorized zones of use*', sub_label: 'Tick one or multiple zones below'
         },
      ]
   },
   company_card_details_right: {
      icon: 'fa fa-user',
      title: 'Contact Details',
      subtitle: 'Provide contact info',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6 input-uppercase', model: 'vehicleReg',
            validation: 'min:7|max:8', label: 'Vehicle Registration', err: '', sub_label_bottom: 'NOTE: Leave blank if you do not wish to restrict this card to one vehicle', sub_label: 'To be imprinted on card'
         },
         {
            type: 'text', form_type: 'email', class: 'col-12 col-md-6', model: 'email',
            validation: 'required|min:3|max:150|email', label: 'Email Address*', err: '', sub_label: 'Provide an active email address'
         },
         {
            type: 'checkbox', class: 'col-12 col-md-6 custom-check padded', model: 'sms', validation: '',
            label: 'SMS Alerts <br> <label class="small-label-bottom">Attract a cost of 0.31 ZMW per alert</label>', sub_label_bottom: ''
         },
         {
            type: 'checkbox', class: 'col-12 col-md-6 custom-check padded', model: 'millageInput', validation: '',
            label: 'Millage Input <br> <label class="small-label-bottom">Select if you want a report of fuel consumption efficiency in Litres per 100Kms</label>'
         },
         {
            type: 'checkbox', class: 'col-12 custom-check padded', model: 'driverCode', validation: '',
            label: 'Driver Code <br> <label class="small-label-bottom">Tick if you want a driver code to be captured on POS, so as to identify each driver individually</label>'
         },
         {
            type: 'checkbox-group', class: 'col-12 col-md-6 laz-radio small', model: 'daysOfUse', validation: 'required',
            options: [
               { val: 'all_days', label: `<div class="group-radio"><div class="black">All Days</div></div>`, class: 'col-12 main-radio no-padding', checked: false, select_all: true},
               { val: 'MONDAY', label: 'Monday', class: 'col-12 col-md-6 main-radio', checked: false},
               { val: 'TUESDAY', label: 'Tuesday', class: 'col-12 col-md-6 main-radio',checked: false},
               { val: 'WEDNESDAY', label: 'Wednesday', class: 'col-12 col-md-6 main-radio',checked: false},
               { val: 'THURSDAY', label: 'Thursday', class: 'col-12 col-md-6 main-radio',checked: false},
               { val: 'FRIDAY', label: 'Friday', class: 'col-12 col-md-6 main-radio',checked: false},
               { val: 'SATURDAY', label: 'Saturday', class: 'col-12 col-md-6 main-radio',checked: false},
               { val: 'SUNDAY', label: 'Sunday', class: 'col-12 col-md-6 main-radio',checked: false},
            ], classes: { radioRow: 'row', radioCol: 'col-12 col-md-6 col-lg-4' }, label: 'Days of use*', sub_label: 'Tick and fill appropriate'
         },
      ]
   },
   card_details_right: {
      icon: 'fa fa-user',
      title: 'Contact Details',
      subtitle: 'Provide contact info',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6 input-uppercase', model: 'vehicleReg',
            validation: 'min:7|max:8', label: 'Vehicle Registration', err: '', sub_label_bottom: 'NOTE: Leave blank if you do not wish to restrict this card to one vehicle', sub_label: 'To be imprinted on card'
         },
         {
            type: 'text', form_type: 'email', class: 'col-12 col-md-6', model: 'email',
            validation: 'required|min:3|max:150|email', label: 'Email Address*', err: '', sub_label: 'Provide an active email address'
         },
         {
            type: 'checkbox', class: 'col-12 col-md-6 custom-check padded', model: 'sms', validation: '',
            label: 'SMS Alerts <br> <label class="small-label-bottom">Attract a cost of 0.31 ZMW per alert</label>', sub_label_bottom: ''
         },
         {
            type: 'checkbox', class: 'col-12 col-md-6 custom-check padded', model: 'millageInput', validation: '',
            label: 'Millage Input <br> <label class="small-label-bottom">Select if you want a report of fuel consumption efficiency in Litres per 100Kms</label>'
         },
         {
            type: 'checkbox', class: 'col-12 custom-check padded', model: 'driverCode', validation: '',
            label: 'Driver Code <br> <label class="small-label-bottom">Tick if you want a driver code to be captured on POS, so as to identify each driver individually</label>'
         },
         {
            type: 'checkbox-group', class: 'col-12 col-md-6 laz-radio small', model: 'daysOfUse', validation: 'required',
            options: [
               { val: 'all_days', label: `<div class="group-radio"><div class="black">All Days</div></div>`, class: 'col-12 main-radio no-padding', checked: false, select_all: true},
               { val: 'MONDAY', label: 'Monday', class: 'col-12 col-md-6 main-radio', checked: false},
               { val: 'TUESDAY', label: 'Tuesday', class: 'col-12 col-md-6 main-radio',checked: false},
               { val: 'WEDNESDAY', label: 'Wednesday', class: 'col-12 col-md-6 main-radio',checked: false},
               { val: 'THURSDAY', label: 'Thursday', class: 'col-12 col-md-6 main-radio',checked: false},
               { val: 'FRIDAY', label: 'Friday', class: 'col-12 col-md-6 main-radio',checked: false},
               { val: 'SATURDAY', label: 'Saturday', class: 'col-12 col-md-6 main-radio',checked: false},
               { val: 'SUNDAY', label: 'Sunday', class: 'col-12 col-md-6 main-radio',checked: false},
            ], classes: { radioRow: 'row', radioCol: 'col-12 col-md-6 col-lg-4' }, label: 'Days of use*', sub_label: 'Tick and fill appropriate'
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'promoCode',
            validation: 'min:6|max:6', label: 'Promo Code', err: '', sub_label: 'This field is not mandatory', sub_label_bottom: 'NOTE: You can provide a code for the pump attendant who reffered you'
         },
      ]
   },
   county_select: {
      icon: 'fa fa-user',
      title: 'OTP',
      subtitle: 'Provide contact info',
      forms: [
         {
            type: 'select', class: 'col-12', model: 'county', filterable: true, clearable: true,
            options: [],label: 'Region',validation: 'required'
         },
      ]
   },
   pickup_station: {
      icon: 'fa fa-user',
      title: 'OTP',
      subtitle: 'Provide contact info',
      forms: [
         {
            type: 'select', class: 'col-12', model: 'station', filterable: true, clearable: true,
            options: [],label: 'Card Pickup Station',validation: 'required'
         },
      ]
   },
   otp_verification: {
      icon: 'fa fa-user',
      title: 'OTP',
      subtitle: 'Provide contact info',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-10 col-md-6 col-lg-5 col-xl-4 big-input', model: 'otp',
            validation: 'required|numeric|min:4|max:4', err: '', placeholder: '****'
         },
      ]
   },
   otp_verification_email: {
      icon: 'fa fa-user',
      title: 'OTP',
      subtitle: 'Provide contact info',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-10 col-md-6 col-lg-5 col-xl-4 big-input', model: 'otp',
            validation: 'required|numeric|min:4|max:4', err: '', placeholder: '****'
         },
      ]
   },
}

export default {
   forms: utils.generateAllFormData(forms),
}